<style scoped>
    hr {
        margin-top: 5px;
        margin-bottom: 5px;
    }
</style>

<template>
    <div class="col-md-12">
        <transition name="fade" :duration="1000">
            <div v-show="loading" class="col-md-12 col-md-offset-5" style="position:absolute; top:0">
                <br /><br /><br />
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </transition>
        <div v-if="!loading">

            <!--<div>
                <ul class="nav nav-pills">
                    <li class="disabled"><h3 style="margin:0px" class="text-primary"><em>{{carehomeDto.name}}</em></h3></li>
                    <li class="pull-right">
                        <router-link :to="{ name: 'patient-create', params: { id: çarehomeId, name: carehomeName }}">
                            Add User
                        </router-link>
                    </li>
                </ul>
                <hr />
            </div>-->
            <CarehomeUserEditForm></CarehomeUserEditForm>
            <br />
        </div>
    </div>
</template>



<script>

    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'

    import CarehomeHeader from './../../appcontrols/CarehomeHeader/CarehomeHeader.scp.html'
    import CarehomeUserTable from './../../appcontrols/carehomeusertable/carehomeusertable.scp.html'
    import CarehomeUserEditForm from './../../appcontrols/CarehomeUserEditForm/CarehomeUserEditForm.scp.html'
    export default {
        props: ['carehomeid' ,'userid'],
        data: function () {
            return {
                loading: true,
                carehomeid: "",
                carehomeDto: null,
                selectedUser: {}
            }
        },
        watch: {
            'selectedUser': function (user) {
                // User clicked - navigate to edit user
                console.log(user.email)
                //this.$router.push({ name: 'pharmacy-carehome-user-form', params: { this.carehomeid, this.userid } })
            }
        },
        mounted: function () {

            var dal = new Dal();
            dal.GetCarehome(this.carehomeid).then(data => {
                this.carehomeDto = data;
                this.loading = false;
            });
        },
        components: {
            CarehomeHeader,
            CarehomeUserTable,
            CarehomeUserEditForm
        }
    }

</script>


// WEBPACK FOOTER //
// carehome-user-form.scp.html?8836eb8a